<template>
  <div>
    <div class="btn-group">
      <button
        class="btn"
        type="button"
        v-for="option in options"
        :class="{ 'btn-primary': selected == option, 'btn-outline-secondary': selected != option }"
        @click="select(option)"
      >
        {{ option | t }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    },
    default_value: {
      required: false,
      default: null
    },
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    selected() {
      return this.value;
    }
  },
  methods: {
    select(option) {
      this.$emit('input', option);
      this.$emit('change', option);
    }
  }
};
</script>
